import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Map = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M8.625 4.5v13.565l-4.917 1.254c-.357.091-.708-.165-.708-.517V6.506a.54.54 0 0 1 .4-.513zm0 0 6.75 1.607m0 13.393V5.935l4.917-1.254c.357-.091.708.165.708.517v12.296a.54.54 0 0 1-.4.513zm0 0-6.75-1.607"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Map) as SvgIcon;
export { ForwardRef as ReactComponent };
